import { ChangeDetectorRef, Component, Input, OnChanges, OnInit } from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {AddAddressComponent} from '../add-address/add-address.component'
import {EntityService} from '../../entity.service';
@Component({
  selector: 'app-address-events',
  templateUrl: './address-events.component.html',
  styleUrls: ['./address-events.component.scss']
})
export class AddressEventsComponent implements OnInit,OnChanges {

  constructor(private _matDialog: MatDialog,public _entityService:EntityService,private _changeDetectorRef: ChangeDetectorRef) { }
  adrsLst=[]
  @Input() cpmntData;
  enty_ky = 0;
  hndlr_nm = '';
  loader;
  @Input() getList:boolean=false;
  ngOnInit(): void {
    this.enty_ky=this.cpmntData.enty_ky;
    this.hndlr_nm=this.cpmntData.hndlr_nm
    this.getAddress(this.enty_ky, this.hndlr_nm)
  }
  ngOnChanges(){
    if(this.getList == true)
    {
      this.getAddress(this.enty_ky,this.hndlr_nm);
    }
  }
  addNewAddress() {
    const dialogRef = this._matDialog.open(AddAddressComponent,{
      data: {
        hndlr_nm: this.hndlr_nm,
        enty_ky: this.enty_ky
      }
    });

    dialogRef.afterClosed()
      .subscribe((result) => {
        this.getAddress(this.enty_ky, this.hndlr_nm)
      });

  }
  getAddress(id,hndlr_nm)
  {
    this.loader=true
    this._entityService.getAddress(id,hndlr_nm).subscribe((res) => {
      this.loader=false
      if (res['status'] == 200) {
        this.adrsLst = res['data'];
        this._changeDetectorRef.markForCheck();
      }
      else {
        this._entityService.openSnackBar(res['message'], 'mat-warn');
      }
      this.adrsLst=res['data']
    })
  }
  edtAddrss(edtData)
  {
    const dialogRef = this._matDialog.open(AddAddressComponent, {
      data: {
        hndlr_nm: this.hndlr_nm,
        enty_ky:this.enty_ky,
        edit_in:1,
        editData:edtData
      }
    });
    dialogRef.afterClosed()
      .subscribe((result) => {
        this._changeDetectorRef.markForCheck();
        this.getAddress(this.enty_ky, this.hndlr_nm)
      });
  }
}
